const Appconfig = {
    // baseurl: "https://europea.api.infiny.dev", 
    // baseurl: "https://newapi.europea-dms.com", 
    baseurl: "https://euroapi.europea-dms.com",
    // baseurl: "http://localhost:4000",
}

export default Appconfig;